import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { MailApi } from './api/client.js';
import { MailController } from './state/mail-store.js';

// Identity is the edge's job: Caddy's forward-auth sets it on every request.
const api = new MailApi({ baseUrl: import.meta.env['VITE_API_BASE_URL'] ?? '' });

const root = document.getElementById('root');
if (root === null) throw new Error('No #root element.');

createRoot(root).render(
  <StrictMode>
    <App controller={new MailController({ api })} api={api} />
  </StrictMode>,
);
